import React from "react";
import data from "../json/Allproducts/Xpertproof.json";
import Section1 from "../components/Allproducts/Section1";
import Section4 from "../components/Allproducts/Section4";
import Section3 from "../components/Allproducts/Section3";

const Xpertproof = () => {
  return (
    <div className="w-full flex flex-col items-center ruler">
      <Section1 data={data}/>
      <Section3 data={data.Section5}/>
      <Section4 data={data.Section4}/>
    </div>
  );
};

export default Xpertproof;
